// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var React = require("react");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");

var errorMessage = "Please ignore this error.";

var throwFakeErrorToFoolNextRouter = (// Throwing an actual error class trips the Next.JS 500 Page, this string literal does not.
      () => { throw errorMessage });

function rejectionHandler($$event) {
  var reason = $$event.reason;
  if (Core__Option.getOr(reason, "").includes(errorMessage)) {
    $$event.preventDefault();
    return ;
  }
  
}

function use(shouldStopNavigation, onNavigate) {
  var router = Next.useRouter();
  var currentPath = Next.Router.asPath(router);
  var match = React.useState(function () {
        
      });
  var setNextPath = match[1];
  var nextPath = match[0];
  var navigationConfirmed = React.useRef(false);
  var killRouterEvent = React.useCallback((function () {
          Next.Router.Events.emit(Next.Router.events(router), {
                NAME: "routeChangeError",
                VAL: [
                  "",
                  "",
                  {
                    shallow: false
                  }
                ]
              });
          throwFakeErrorToFoolNextRouter();
        }), [router]);
  React.useEffect((function () {
          navigationConfirmed.current = false;
          var onRouteChange = function (url) {
            if (shouldStopNavigation && url !== currentPath && !navigationConfirmed.current) {
              setNextPath(function (param) {
                    return url.replace(Next.Router.basePath(router), "");
                  });
              onNavigate();
              return killRouterEvent();
            }
            
          };
          Next.Router.Events.on(Next.Router.events(router), {
                NAME: "routeChangeStart",
                VAL: onRouteChange
              });
          window.addEventListener("unhandledrejection", rejectionHandler);
          return (function () {
                    Next.Router.Events.off(Next.Router.events(router), {
                          NAME: "routeChangeStart",
                          VAL: onRouteChange
                        });
                    window.removeEventListener("unhandledrejection", rejectionHandler);
                  });
        }), [
        currentPath,
        killRouterEvent,
        onNavigate,
        setNextPath,
        shouldStopNavigation
      ]);
  if (nextPath !== undefined) {
    return (function () {
              navigationConfirmed.current = true;
              Next.Router.push(nextPath, undefined, undefined, router);
            });
  }
  
}

exports.errorMessage = errorMessage;
exports.throwFakeErrorToFoolNextRouter = throwFakeErrorToFoolNextRouter;
exports.rejectionHandler = rejectionHandler;
exports.use = use;
/* Next Not a pure module */
